import React from 'react';

const CustomHorizontalBar = (props) => {
  let { ele, EditDetailsFn, getAssessmentDimensionsData, isTop, getAssessmentDimensionsMngrData, isManager } = props;


  function getColor(dimension) {
    let colorCode = "#757575";
    if (getAssessmentDimensionsData && getAssessmentDimensionsData.length > 0) {
      let getIndex = getAssessmentDimensionsData.findIndex(prev => prev.dimension === dimension);
      if (getIndex !== -1) {
        colorCode = getAssessmentDimensionsData[getIndex]["colorCode"];
      }
    }
    return colorCode;
  }


  //console.log("getAssessmentDimensionsData-------->", getAssessmentDimensionsData)
  let list = [];
  if (!isManager) {
    if (Object.keys(ele) && Object.keys(ele).length > 0) {
      //console.log("el2e-------->", Object.keys(ele))
      let arrayEle = Object.keys(ele);

      const index = arrayEle.indexOf("emp_id");
      if (index > -1) {
        arrayEle.splice(index, 1);
      }

      const index2 = arrayEle.indexOf("name");
      if (index2 > -1) {
        arrayEle.splice(index2, 1);
      }

      for (var i = 0; i < arrayEle.length; i++) {
        let rankNumber = parseInt(arrayEle[i].replace('Rank', ''));
        let dimension = ele["Rank" + rankNumber.toString()]

        if (rankNumber) {
          list.push({
            dimension: dimension,
            rank: rankNumber,
            colorCode: getColor(dimension)
          });
        }
      }


    }

    //console.log("list-------->", list)

    if (list && list.length > 0) {
      list.sort((a, b) => a.rank - b.rank);
    }
  }




  function getTopBottomIndex(list, type) {
    let range1 = 0;
    let range2 = 0;
    if (list && list.length > 0) {
      if (type === "top") {
        range1 = 5;
        range2 = 5;
      } else if (type === "mid") {
        range1 = 6;
        range2 = list.length - 5;
      } else if (type === "bottom") {
        range1 = list.length - 4
        range2 = list.length - 4
      }
    }
    return {
      "range1": range1,
      "range2": range2
    }
  }



  function getDataMNGRList(x_list, type) {

    let AssessmentList = x_list;

    console.log("AssessmentList--1->", AssessmentList)

    let dataNewList = [];
    console.log("type--1->", type)

    if (type === "Top") {
      if (AssessmentList && AssessmentList.length > 0) {
        for (var i = 0; i < AssessmentList.length; i++) {
          let element = AssessmentList[i];
          if ((i + 1 <= getTopBottomIndex(AssessmentList, "top").range1)) {
            // dataList.push({ value: (i + 1) * 20, name: (i + 1).toString(), itemStyle: { color: element && element.colorCode ? element.colorCode : "#757575" } })
            dataNewList.push(element)
            console.log("element--1->", element)

          }
        }
      }
    }

    if (type === "Bottom") {
      if (AssessmentList && AssessmentList.length > 0) {
        for (var i = 0; i < AssessmentList.length; i++) {
          let element = AssessmentList[i];
          if (getTopBottomIndex(AssessmentList, "bottom").range1 <= i + 1) {
            // dataList.push({ value: ((i - getTopBottomIndex(AssessmentList, "bottom").range1) + 2) * 20, name: ((i - getTopBottomIndex(AssessmentList, "bottom").range1) + 2).toString(), itemStyle: { color: element && element.colorCode ? element.colorCode : "#757575" }})
            dataNewList.push(element)
            console.log("element--1->", element)

          }
        }
      }
    }
    console.log("dataNewList--1->", dataNewList)

    return dataNewList;
  }


  // const managerThemes = [
  //   { number: 1, title: "Values", description: "You live your life with certain core, non negotiable values.", bg: "bg-blue-100", numberBg: "bg-blue-500" },
  //   { number: 2, title: "Coach", description: "Everyone has immense potential and you love bringing out that potential in everyone.", bg: "bg-green-100", numberBg: "bg-green-600" },
  //   { number: 3, title: "Finisher", description: "If you start something you will love to finish it. You do not get tired from work.", bg: "bg-blue-100", numberBg: "bg-blue-500" }
  // ];

  const managerThemes = isManager ? getDataMNGRList(getAssessmentDimensionsMngrData, isTop ? "Top" : "Bottom") : [];



  return (<>

    {isTop ?
      <>

        {isManager ?
          <div className='flex  w-full divide-x divide-white'>
            {managerThemes && managerThemes.length > 0 ?
              managerThemes.map((element, index) =>
                (index < 5) ?
                  <div
                    style={{
                      background:
                        element && element.colorCode
                          ? element.colorCode
                          : "#DDDDDD",
                    }}
                    className={
                      "w-full px-6 py-2 text-base font-medium flex text-white text-center justify-center  "
                    }>{(index + 1).toString()}. {EditDetailsFn(element, "dimension", element.dimension)}</div>
                  : null) : null}
          </div>

          : null}


        <div className='flex  w-full divide-x divide-white'>
          {list && list.length > 0 ?
            list.map((element, index) =>
              (index < 5) ?
                <div
                  style={{
                    background:
                      element && element.colorCode
                        ? element.colorCode
                        : "#DDDDDD",
                  }}
                  className={
                    "w-full px-6 py-2 text-base font-medium flex text-white text-center justify-center  "
                  }>{(index + 1).toString()}. {EditDetailsFn(element, "dimension", element.dimension)}</div>
                : null) : null}
        </div>

      </>
      :
      <>

        {isManager && true ?
          <div className='flex  w-full divide-x divide-white'>
            {managerThemes && managerThemes.length > 0 ?
              managerThemes.map((element, index) =>
                (getTopBottomIndex(list, "bottom").range1 <= index + 1) ?
                  <div
                    style={{
                      background:
                        element && element.colorCode
                          ? element.colorCode
                          : "#DDDDDD",
                    }}
                    className={
                      "w-full px-6 py-2 text-base font-medium flex text-white text-center justify-center  "
                    }>{((index - getTopBottomIndex(list, "bottom").range1) + 1).toString()}. {EditDetailsFn(element, "dimension", element.dimension)}</div>
                  : null) : null}
          </div>
          : null}



        <div className='flex  w-full divide-x divide-white'>
          {list && list.length > 0 ?
            list.map((element, index) =>
              (getTopBottomIndex(list, "bottom").range1 <= index + 1) ?
                <div
                  style={{
                    background:
                      element && element.colorCode
                        ? element.colorCode
                        : "#DDDDDD",
                  }}
                  className={
                    "w-full px-6 py-2 text-base font-medium flex text-white text-center justify-center  "
                  }>{((index - getTopBottomIndex(list, "bottom").range1) + 2).toString()}. {EditDetailsFn(element, "dimension", element.dimension)}</div>
                : null) : null}
        </div>
      </>}


  </>);
};

export default CustomHorizontalBar;
